import React from 'react'
import {createSearchParams, Link, useNavigate, useSearchParams} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolId, getSchoolYear} from "../../../../../utils/authority";
import vi from "date-fns/locale/vi";
import TableHeader from "../../../../../components/TableHeader";
import Pagination from "../../../../../components/Pagination";
import Utils from "../../../../../utils/utils";
import PublicSecureAuthorization
    from "../../../../../services/system/secure-authorization/secure-authorization-controller";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import CLBController from "../../../../../services/system/clb/clb-controller";
import ModalAddStudentToCLB from "../modalAddStudentToCLB";
import CLBRegisterController from "../../../../../services/system/clb-register/clb-register-controller";
import ModalDeleteStudentInCLB from "../modalDeleteStudentInCLB";
import ModalEditStudentInCLB from "../modalEditStudentInCLB";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} params={useSearchParams()}/>;
}
class DetailRegisterCLBManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDay: new Date(),
            endDay: new Date(),
            state: 'WAIT_PUBLISH',
            price: 0,
            surcharge: 0,
            principalId: '',
            principalName: '',
            principalUsername: '',

            dateActive: null,
            gradeStr: "",
            title: "",
            groupId: 0,
            yearId: parseInt(getSchoolYear()),
            recipientId: 0,
            content: "",
            listGroupUser: [],
            classRoomId: 0,
            listClassRoom: [],
            files: [],

            listStudentActive: [],
            listStudentCancel: [],
            pageNumberActive: 0,
            pageSizeActive: 100,
            totalItemActive: 0,

            pageNumberCancel: 0,
            pageSizeCancel: 100,
            totalItemCancel: 0,

            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên học sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "class",
                    name: "Lớp",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "date",
                    name: "Ngày đăng ký",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Chú thích",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "payment",
                    name: "Thanh toán",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "action",
                    name: "Hành động",
                    style: {textAlign: "center"},
                    sort: false
                }
            ],
            headerCancel: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên học sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "class",
                    name: "Lớp",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "dateCreate",
                    name: "Ngày đăng ký",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "dateCancel",
                    name: "Ngày hủy",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "person",
                    name: "Người hủy",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "payment",
                    name: "Lý do hủy",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "action",
                    name: "Hành động",
                    style: {textAlign: "center"},
                    sort: false
                }
            ],
        };
    }

    componentWillMount() {
        const [searchparams] = this.props.params;
        let clbId = parseInt(searchparams.get("id"));
        this.setState(
            {
                clbId: clbId
            },()=> {
                this.getDetailCLB()
                this.getListStudent("ACTIVE")//ACTIVE, SCHOOL_CANCEL, PARENT_CANCEL
                this.getListStudent("CANCEL")//ACTIVE, SCHOOL_CANCEL, PARENT_CANCEL
        }
        );
        this.getAllClass()
        this.getListGroupUser()
    }
    updateView(){
        this.getListStudent("ACTIVE")//ACTIVE, SCHOOL_CANCEL, PARENT_CANCEL
        this.getListStudent("CANCEL")//ACTIVE, SCHOOL_CANCEL, PARENT_CANCEL
    }
    getListStudent(state) {
        let payload = {
            clbId: this.state.clbId,
            state: state,
            studentId: this.state.studentId,
            schoolId: parseInt(getSchoolId()),
            yearId: parseInt(getSchoolYear()),
            pageNumber: state == "ACTIVE"?this.state.pageNumberActive:this.state.pageNumberCancel,
            pageSize: state == "ACTIVE"?this.state.pageSizeActive:this.state.pageSizeCancel,
            "sort": "created_at desc"
        };
        CLBRegisterController.list(payload,res => {
            if (res.success) {
                let data = res.data.content;
                if (state == "ACTIVE") {
                    this.setState(
                        {
                            listStudentActive: data
                        }
                    );
                }else {
                    this.setState(
                        {
                            listStudentCancel: data
                        }
                    );
                }

            } else {
            }
        });
    }
    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listGroupUser: res.data.content
                    }
                );
            } else {
            }
        });
    }
    getAllClass = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderStatus() {
        let listStatus = [
            {
                "id": "WAIT_PUBLISH",
                "name": "Chờ phát hành"
            },
            {
                "id": "PUBLISH",
                "name": "Đã phát hành"
            },
            {
                "id": "LOCKED",
                "name": "Đã khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    onEdit = () => {
        let price = parseFloat(this.state.price.toString().replaceAll(",", ""))
        let surcharge = parseFloat(this.state.price.toString().replaceAll(",", ""))

        let {name} = this.state;
        if (name == "" || name.length < 5){
            toast.error("Tên CLB phải lớn hơn 5 ký tự");
        }else if(this.state.content == ""){
            toast.error("Vui lòng nhập nội dung CLB");
        }else {
            let payload = {
                "id": this.state.id,
                "name": this.state.name,
                "headTeacherId": parseInt(this.state.principalId),
                "state": this.state.state,
                "numberSessions": parseInt(this.state.numberSessions),
                "price": price,
                "surcharge": surcharge,
                "content": this.state.content,
                "schoolDay": this.state.schoolDay,
                "startDay": moment(this.state.startDay).format("yyyy-MM-DD"),
                "endDay": moment(this.state.endDay).format("yyyy-MM-DD"),
                "schoolId": parseInt(getSchoolId()),
                "yearId": parseInt(getSchoolYear()),
            }
            CLBController.edit(payload, res => {
                if (res.success){
                    this.props.navigate('/ad-sas-school/quan-ly-lop-clb');
                    toast.success("Tạo CLB thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }

    getDetailCLB() {
        CLBController.detail(this.state.clbId, res => {
            if (res.success){
                this.setState({
                    "content": res.data.content,
                    "endDay": res.data.endDay,
                    "id": res.data.id,
                    "name": res.data.name,
                    "numberSessions": res.data.numberSessions,
                    "price": res.data.price,
                    "schoolDay": res.data.schoolDay,
                    "startDay": res.data.startDay,
                    "state": res.data.state,
                    "surcharge": res.data.surcharge,
                    "principalName": res.data.headTeacherRes?.fullName,
                    "principalId": res.data.headTeacherRes?.id,
                })
            }else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }
        })
    }
    getHp1Buoi() {
        let total = parseInt(this.state.numberSessions)
        if (total< 1)
            total = 1
        let price = parseFloat(this.state.price.toString().replaceAll(",", ""))
        let hp = Utils.formatMoney(Math.round(price/total))
        return hp + " đ"
    }
    render() {
        let {header, headerCancel, listStudentActive, listStudentCancel} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="register-clb" parentClass="clb-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Chi tiết đăng ký lớp CLB"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>Chi tiết đăng ký lớp CLB</h2>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Thông tin lóp CLB
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên lớp CLB</label>
                                                <label className="col-8 label-item pl-0"><b>{this.state.name}</b></label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên giáo viên</label>
                                                <label className="col-4 label-item pl-0"><b>{this.state.headTeacherRes?.fullName}</b></label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày bắt đầu</label>
                                                <label className="col-4 label-item pl-0"><b>{moment(this.state.startDay).format("DD-MM-YYYY").toString()}</b></label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày kết thúc</label>
                                                <DatePicker
                                                    placeholderText="Ngày-Tháng-Năm"
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.endDay === '' ? null : new Date(this.state.endDay)}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    endDay: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số buổi học</label>
                                                <label className="col-4 label-item pl-0"><b>{this.state.numberSessions}</b></label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Học phí</label>
                                                <label className="col-4 label-item pl-0"><b>{Utils.formatMoney(this.state.price)} đ</b></label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Học phí 1 buổi</label>
                                                <label className="col-4 label-item pl-0"><b>{this.getHp1Buoi()}</b></label>
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Phụ phí</label>
                                                <label className="col-4 label-item pl-0"><b>{Utils.formatMoney(this.state.surcharge)} đ</b></label>
                                            </div>
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Danh sách học sinh đã đăng ký lớp CLB
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex mb-1"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <button
                                                    style={{height: 35, marginRight: 12}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.setState({showModalCreate: true})}
                                                >
                                                    Thêm học sinh
                                                </button>
                                            </div>
                                            <div className="card col-12">
                                                <div className="p-0 mb-3">
                                                    <div className="table-wrapper">
                                                        <table
                                                            className="table table-striped table-data table-responsive table-bordered">
                                                            <table className="table">
                                                                <thead>
                                                                <TableHeader
                                                                    header={header}
                                                                    clickSort={data => {
                                                                    }}
                                                                />
                                                                </thead>
                                                                {!listStudentActive ||
                                                                listStudentActive.length == 0 ? (
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <div className="text-center">
                                                                                Không có dữ liệu
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                ) : (
                                                                    <tbody>
                                                                    {listStudentActive &&
                                                                    listStudentActive.length > 0 &&
                                                                    listStudentActive?.map((row, index) => (
                                                                        <tr style={{height: 50}}>
                                                                            <td style={{textAlign: "center"}} scope="row">
                                                                                {" "}
                                                                                {this.state.pageNumberActive * this.state.pageSizeActive +
                                                                                index +
                                                                                1}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {row.studentRes?.fullName}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {row.studentRes?.currentClassRoomRes?.name}
                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                {moment(row.createdAt).format("DD-MM-YYYY")}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}}>
                                                                                {row.note}
                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                {row.state=="INACTIVE" ? <span className="badge badge-danger" style={{color: "white"}}>Chưa thanh toán</span> : <span className="badge badge-success" style={{color: "white"}}>Đã thanh toán</span>}
                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                <button className="btn btn-action p-2"
                                                                                        title='Cập nhật học sinh'
                                                                                        style={{cursor: 'pointer'}}
                                                                                        onClick={() => {
                                                                                            this.setState({itemSelected: row, showModalRemoveStudent: true})
                                                                                        }}
                                                                                >
                                                                                    <i className="ti-pencil-alt"/>
                                                                                </button>
                                                                                <button className="btn btn-action p-2"
                                                                                        title='Xóa học sinh'
                                                                                        style={{cursor: 'pointer'}}
                                                                                        onClick={() => {
                                                                                            this.setState({itemSelected: row, showModalDeleteStudent: true})
                                                                                        }}
                                                                                >
                                                                                    <i className="ti-trash"/>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    </tbody>
                                                                )}
                                                            </table>
                                                        </table>
                                                    </div>
                                                    <div className="pagination-right">
                                                        <Pagination
                                                            activePage={this.state.pageNumberActive}
                                                            itemsCountPerPage={this.state.pageSizeActive}
                                                            totalItemsCount={this.state.totalItemActive}
                                                            changeHandler={page => this.handleChangePage(page)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12 d-flex mb-2 bg-top-title-warn mt-2">
                                                Danh sách học sinh hủy đã đăng ký lớp CLB
                                            </div>
                                            <div className="card col-12">
                                                <div className="p-0 mb-3">
                                                    <div className="table-wrapper">
                                                        <table
                                                            className="table table-striped table-data table-responsive table-bordered">
                                                            <table className="table">
                                                                <thead>
                                                                <TableHeader
                                                                    header={headerCancel}
                                                                    clickSort={data => {
                                                                    }}
                                                                />
                                                                </thead>
                                                                {!listStudentCancel ||
                                                                listStudentCancel.length == 0 ? (
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <div className="text-center">
                                                                                Không có dữ liệu
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                ) : (
                                                                    <tbody>
                                                                    {listStudentCancel &&
                                                                    listStudentCancel.length > 0 &&
                                                                    listStudentCancel?.map((row, index) => (
                                                                        <tr style={{height: 50}}>
                                                                            <td style={{textAlign: "center"}} scope="row">
                                                                                {" "}
                                                                                {this.state.pageNumberCancel * this.state.pageSizeCancel +
                                                                                index +
                                                                                1}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {row.studentRes?.fullName}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {row.studentRes?.currentClassRoomRes?.name}
                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                {moment(row.createdAt).format("DD-MM-YYYY")}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}}>
                                                                                {moment(row.updatedAt).format("DD-MM-YYYY")}

                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                {row.state=="SCHOOL_CANCEL" ? <span className="badge badge-danger" style={{color: "white"}}>Nhà trường hủy</span> : <span className="badge badge-warning" style={{color: "white"}}>Phụ huynh hủy</span>}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {row.note}
                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                <button className="btn btn-action p-2"
                                                                                        title='Cập nhật học sinh'
                                                                                        style={{cursor: 'pointer'}}
                                                                                        onClick={() => {
                                                                                            this.setState({itemSelected: row, showModalRemoveStudent: true})
                                                                                        }}
                                                                                >
                                                                                    <i className="ti-pencil-alt"/>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    </tbody>
                                                                )}
                                                            </table>
                                                        </table>
                                                    </div>
                                                    <div className="pagination-right">
                                                        <Pagination
                                                            activePage={this.state.pageNumberCancel}
                                                            itemsCountPerPage={this.state.pageSizeCancel}
                                                            totalItemsCount={this.state.totalItemCancel}
                                                            changeHandler={page => this.handleChangePage(page)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4  border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/quan-ly-dang-ky-clb"
                                                }}
                                            >
                                                Quay lại
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalAddStudentToCLB
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.getListStudent("ACTIVE")}
                    item={this.state}
                />
                <ModalDeleteStudentInCLB
                    show={this.state.showModalDeleteStudent}
                    onHide={() => this.setState({showModalDeleteStudent: false})}
                    onRefresh={() => this.getListStudent("ACTIVE")}
                    item={this.state.itemSelected}
                />
                <ModalEditStudentInCLB
                    show={this.state.showModalRemoveStudent}
                    onHide={() => this.setState({showModalRemoveStudent: false})}
                    onRefresh={() => this.updateView()}
                    item={this.state.itemSelected}
                />
            </div>
        )
    }
}
export default withRouter(DetailRegisterCLBManagement)